/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import SiteShell from './SiteShell.jsx'
import Tree from './Tree.jsx'
import SelfEval from './SelfEval.jsx'
import { FaqItem } from '../components/Faq.jsx'

const ORDER_URL = 'https://app.sequoia.fitness/new-order'

export default function ProgramPage({ data }) {
  const ctaLabel = data.cta || 'دریافت برنامه'
  return (
    <SiteShell variant="program">
      <section className="pg-hero">
        <div className="pg-hero__text">
          <h1>{data.hero_text.title}</h1>
          <p>{data.hero_text.sub}</p>
          <a className="pg-cta" href={ORDER_URL} target="_blank" rel="noopener">
            {ctaLabel}
          </a>
        </div>
        {data.hero && (
          <div className="pg-hero__img">
            <img src={data.hero} alt="" width="1024" height="576" fetchPriority="high" />
          </div>
        )}
      </section>
      <div className="main-content-wrapper">
        {data.blocks.map((b, i) => (b.t === 'selfEval' ? <SelfEval data={data.selfEval} key={i} /> : <Tree node={b} key={i} />))}
      </div>
      <section className="seq-faq pg-faq" aria-label={data.faqTitle} dir="rtl">
        <h2 className="tm-title">{data.faqTitle}</h2>
        <div className="seq-faq-list">
          {data.faq.map((f) => (
            <FaqItem key={f.q} q={f.q} a={f.a.map((n, i) => <Tree node={n} key={i} />)} />
          ))}
        </div>
      </section>
      <section className="pg-cta-band">
        <h2>آماده‌ای شروع کنی؟</h2>
        <p>برنامه‌ی اختصاصی خودت رو همین الان از پلتفرم سکویا بگیر.</p>
        <a className="pg-cta" href={ORDER_URL} target="_blank" rel="noopener">
          {ctaLabel}
        </a>
      </section>
    </SiteShell>
  )
}
